/* eslint-disable react/prop-types */
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from "chart.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

/** Horizontal bar breakdown of giving totals by category (offerings/tithes/welfare/harvest). */
export default function CategoryDistributionChart({ labels, data, colors }) {
  const hasData = data && data.length > 0 && data.some((v) => Number(v) > 0);

  if (!hasData) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No giving recorded yet.
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderRadius: 6,
        maxBarThickness: 28,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (item) =>
            `GHS ${Number(item.raw).toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
        },
      },
    },
    scales: {
      x: { beginAtZero: true },
      y: { grid: { display: false } },
    },
  };

  return (
    <Box sx={{ height: { xs: 220, md: 260 } }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
}
